import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

interface filterItem {
	value: string;
	name: string;
}

@Component({
	selector: 'app-filters-modal',
	templateUrl: './filters-modal.component.html',
	styleUrls: ['./filters-modal.component.scss'],
	standalone: false,
})
export class FiltersModalComponent implements OnInit {
	public selectedFilters: Set<string> = new Set();
	listFilters: filterItem[] = [
		{
			value: 'warm',
			name: 'filter_section.filters_options.warm',
		},
		{
			value: 'cold',
			name: 'filter_section.filters_options.cold',
		},
		{
			value: 'fish',
			name: 'filter_section.filters_options.fish',
		},
		{
			value: 'chicken',
			name: 'filter_section.filters_options.chicken',
		},
		{
			value: 'beef',
			name: 'filter_section.filters_options.beef',
		},
		{
			value: 'pork',
			name: 'filter_section.filters_options.pork',
		},
	];

	constructor(private modalCtrl: ModalController) {}

	static async show(modalCtrl: ModalController, selectedFilters: string[]): Promise<string[]> {
		const modal = await modalCtrl.create({
			component: FiltersModalComponent,
			cssClass: 'lang-modal auto-height',
			componentProps: {
				selectedFilters: new Set(selectedFilters),
			},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		const response = await modal.onDidDismiss();
		return response.data;
	}

	ngOnInit() {}

	dismiss() {
		this.modalCtrl.dismiss();
	}

	toggle(option: filterItem) {
		if (this.selectedFilters.has(option.value)) {
			this.selectedFilters.delete(option.value);
		} else {
			this.selectedFilters.add(option.value);
		}
	}

	confirm() {
		this.modalCtrl.dismiss(Array.from(this.selectedFilters));
	}

	isSelected(option: filterItem): boolean {
		return this.selectedFilters.has(option.value);
	}
}
